module.exports = __webpack_public_path__ + "img/route-update.04423a80.svg";